peque.api = function (route, params, method)
{
    'use strict';
    
    this.METHOD_GET = "get";
    this.METHOD_POST = "post";
    this.BASE_URL = CURRENT_DOMAIN + '/api/';
    
    if (typeof params === "undefined" || params == null) {
        params = {};
    }
    if (typeof method === "undefined" || method == null) {
        method = this.METHOD_GET;
    }
    
    peque.navigation.showLoader();

    return new Promise((resolve, reject) => {

        let request = {
            method: method,
        };

        let paramList;

        // json body or already a FormData
        if (params instanceof FormData || params instanceof URLSearchParams) {
            paramList = params;
        } else if (typeof params === "string") {
            request.headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            paramList = params;
        } else {
            if (method === this.METHOD_POST) {
                paramList = new FormData();
            } else {
                paramList = new URLSearchParams();
            }
    
            for (let k in params) {
                if (!params.hasOwnProperty(k)) {continue;}
                paramList.append(k, params[k]);
            }
        }

        if (method === "post") {
            request.body = paramList;
        } else {
            route = route + "?" + paramList;
        }

        fetch(this.BASE_URL + route, request)
            .then(response => response.json().then((response) => {
                peque.navigation.hideLoader();
            
                if (response === "" || typeof response != "object" || typeof response.error === "undefined"  || isNaN(response.error)) {
                    peque.navigation.showError("internal error :(");
                    return false;
                }
            
                if (response.error > 0) {
                    peque.navigation.parseError(response, () => {
                        reject(response);
                    });
                    return;
                }
            
                resolve(response);
            }))
            .catch(error => reject(error));
    });
};